import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PosAppService } from '../services/pos.app.service';
import { PosHttpService } from '../services/pos.http.service';
import { FnToasterService } from 'foundation';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private posHttpSvcs: PosHttpService,
    private posAppSvcs:PosAppService,
    private toastr:FnToasterService
  ) { }

  getCLientData() {
    this.posHttpSvcs.unauthPost('v1/auth/idp',null,{}).subscribe((resp:any) =>{
      if(resp.isError){
        this.toastr.error(resp.message);
        return;
      }
      if(resp.isIdpEnabled){
        window.location.href=resp.idRequestUrl;
      }
    });

  }

  
  login(username:string,passwordHash:string) {
    const objectHash={
      username:username,
      password:passwordHash
    }

    this.posHttpSvcs.unauthPost('v1/auth/login',objectHash['username'],objectHash).subscribe((resp:any) =>{
      if(!resp.isError){
        // this.posAppSvcs.setLoginResponse(resp);
        this.posAppSvcs.setAuthToken("Bearer_" + resp.token);
         this.loadMenuData();
      }else {
        this.toastr.error('Invalid login credintials ⚠️');
      }
    });
  }

  loadMenuData(){
    this.posHttpSvcs.authGet('v1/auth/menues','menues').subscribe((resp:any) =>{
      if(resp.isError){
        this.toastr.error('Invalid login credintials ⚠️');
        return;
      }
      this.posAppSvcs.setLoginResponse(resp);
    });
  }
  


}
